module.exports = __webpack_public_path__ + "440173a542aea32e5bdcd534cc3005a6.png";